<!-- eslint-disable vue/no-v-html -->
<template>
    <div v-if="isAiGenerated" class="pb-3">
        {{ $t('product.detail.description.aiGenerated') }}
    </div>
    <div
        v-if="product?.description"
        class="product-description prose lg:max-w-[66%] overflow-scroll no-scrollbar"
        v-html="product?.description"
    />
</template>

<script setup lang="ts">
const { product } = useProduct()

const { locale } = useI18n()
const humanLanguages = [
    'de',
    'en'
]
const isAiGenerated = computed(() => {
    return !humanLanguages.includes(locale?.value)
})
</script>
